const trimStartAndStripStr = (str) => str.trimStart().replace(/ +/g, " ").trimEnd()

export default trimStartAndStripStr